import { render, staticRenderFns } from "./SaleSalesmanOrderModal.vue?vue&type=template&id=23ae2de5&"
import script from "./SaleSalesmanOrderModal.vue?vue&type=script&lang=js&"
export * from "./SaleSalesmanOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports